function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { renderless as renderless$2, api as api$2 } from "@opentiny/vue-renderless/tabs/vue";
import { $prefix, $props, setup as _setup, defineComponent, props } from "@opentiny/vue-common";
import { t } from "@opentiny/vue-locale";
import { renderless as renderless$1, api as api$1 } from "@opentiny/vue-renderless/tab-nav/vue";
import Dropdown from "@opentiny/vue-dropdown";
import DropdownMenu from "@opentiny/vue-dropdown-menu";
import DropdownItem from "@opentiny/vue-dropdown-item";
import Tooltip from "@opentiny/vue-tooltip";
import { iconChevronLeft, iconChevronRight, iconClose, iconPlus } from "@opentiny/vue-icon";
import { renderless, api } from "@opentiny/vue-renderless/tab-bar/vue";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

import "@opentiny/vue-theme/tabs/index.css";
var __vue2_script$2 = {
  name: $prefix + "TabBar",
  props: _extends({}, $props, {
    tabs: Array
  }),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api,
      mono: true
    });
  }
};
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "tiny-tabs__active-bar",
    class: "is-" + _vm.state.rootTabs.position,
    style: _vm.state.barStyle
  });
};
var staticRenderFns = [];
var __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(__vue2_script$2, render, staticRenderFns, false, __vue2_injectStyles$2, null, null, null);
function __vue2_injectStyles$2(context) {
  for (var o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var TabBar = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var getOrderedPanes = function getOrderedPanes2(state, panes) {
  var slotDefault = state.rootTabs.$slots.default;
  var orders;
  if (typeof slotDefault === "function") {
    orders = [];
    var tabVnodes = slotDefault();
    var handler = function handler2(_ref) {
      var type = _ref.type, componentOptions = _ref.componentOptions, props2 = _ref.props;
      var componentName = type && type.componentName;
      if (!componentName)
        componentName = componentOptions && componentOptions.Ctor.extendOptions.componentName;
      if (componentName === "TabItem") {
        var paneName = props2 && props2.name || componentOptions && componentOptions.propsData.name;
        orders.push(paneName);
      }
    };
    tabVnodes.forEach(function(_ref2) {
      var type = _ref2.type, componentOptions = _ref2.componentOptions, props2 = _ref2.props, children = _ref2.children;
      if (type && (type.toString() === "Symbol(Fragment)" || // vue@3.3之前的开发模式
      type.toString() === "Symbol(v-fgt)" || //   vue@3.3.1 的变更
      type.toString() === "Symbol()")) {
        Array.isArray(children) && children.forEach(function(_ref3) {
          var type2 = _ref3.type, componentOptions2 = _ref3.componentOptions, props3 = _ref3.props;
          return handler({
            type: type2,
            componentOptions: componentOptions2,
            props: props3
          });
        });
      } else {
        handler({
          type,
          componentOptions,
          props: props2
        });
      }
    });
  }
  if (orders) {
    var tmpPanes = [];
    orders.forEach(function(paneName) {
      var pane = panes.find(function(pane2) {
        return pane2.name === paneName;
      });
      if (pane)
        tmpPanes.push(pane);
    });
    panes = tmpPanes;
  }
  return panes;
};
var __vue2_script$1 = {
  name: $prefix + "TabNav",
  components: {
    TabBar,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Tooltip,
    IconChevronLeft: iconChevronLeft(),
    IconChevronRight: iconChevronRight(),
    IconClose: iconClose()
  },
  props: _extends({}, $props, {
    panes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentName: String,
    editable: Boolean,
    onTabClick: {
      type: Function,
      default: function _default2() {
      }
    },
    onTabRemove: {
      type: Function,
      default: function _default3() {
      }
    },
    tabStyle: String,
    stretch: Boolean,
    showMoreTabs: Boolean,
    showPanesCount: Number,
    popperClass: String,
    dropConfig: {
      type: Object,
      default: function _default4() {
        return null;
      }
    },
    tooltipConfig: [String, Object]
  }),
  inject: ["moreIcon"],
  setup: function setup2(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless: renderless$1,
      api: api$1,
      mono: true
    });
  },
  render: function render3() {
    var h = arguments[0];
    var state = this.state, tabStyle = this.tabStyle, editable = this.editable, stretch = this.stretch, showPanesCount = this.showPanesCount, onTabClick = this.onTabClick, onTabRemove = this.onTabRemove, scrollNext = this.scrollNext, scrollPrev = this.scrollPrev, changeTab = this.changeTab, tooltipConfig = this.tooltipConfig;
    var panes = this.panes, setFocus = this.setFocus, removeFocus = this.removeFocus, showMoreTabs = this.showMoreTabs, popperClass = this.popperClass, moreIcon = this.moreIcon;
    var spans = [h("span", {
      "class": ["tiny-tabs__nav-prev", state.scrollable.prev ? "" : "is-disabled"],
      "on": {
        "click": scrollPrev
      }
    }, [h("icon-chevron-left")]), !showMoreTabs ? h("span", {
      "class": ["tiny-tabs__nav-next", state.scrollable.next ? "" : "is-disabled"],
      "on": {
        "click": scrollNext
      }
    }, [h("icon-chevron-right")]) : null];
    var scrollBtn = state.scrollable ? spans : null;
    var moreTabs = null;
    if (showMoreTabs && state.scrollable) {
      var reference = function reference2() {
        return moreIcon ? h("span", {
          "class": "tiny-tabs__more-icon"
        }, [moreIcon() || t("ui.tabs.moreItem")]) : h("span", {
          "class": "tiny-tabs__more"
        }, [t("ui.tabs.moreItem")]);
      };
      var dropdowpList = panes.slice(showPanesCount);
      var isShowDropDown = showPanesCount !== -1 && Boolean(dropdowpList.length);
      var menuSlot = function menuSlot2() {
        return isShowDropDown ? dropdowpList.map(function(pane, index) {
          var tabName = pane.name || pane.state.index || index;
          var tabLabelContent = pane.$slots.title || pane.title;
          var tabindex = pane.state.active ? 0 : -1;
          pane.state.index = "" + (index + showPanesCount);
          return h("dropdown-item", {
            "class": "tiny-tabs__more-item",
            "attrs": {
              "tabindex": tabindex
            },
            "on": {
              "focus": function focus() {
                setFocus();
              },
              "blur": function blur() {
                removeFocus();
              },
              "click": function click(e) {
                removeFocus();
                onTabClick(pane, tabName, e);
              }
            }
          }, [typeof tabLabelContent === "function" ? tabLabelContent() : tabLabelContent]);
        }) : null;
      };
      var dropdownSlot = function dropdownSlot2() {
        return isShowDropDown ? h(DropdownMenu, {
          attrs: {
            popperClass: "tiny-tabs-dropdown tiny-tabs__more-dropdown" + (popperClass ? " " + popperClass : ""),
            placement: "bottom-start"
          },
          scopedSlots: {
            default: menuSlot
          }
        }) : null;
      };
      var moreContent = isShowDropDown ? h(Dropdown, {
        attrs: {
          trigger: "hover"
        },
        scopedSlots: {
          default: reference,
          dropdown: dropdownSlot
        }
      }) : reference();
      moreTabs = h("div", {
        "class": "tiny-tabs__more-container",
        "ref": "more"
      }, [moreContent]);
    }
    var tabs = getOrderedPanes(state, panes).map(function(pane, index) {
      var _class;
      var tabName = pane.name || pane.state.index || index;
      var withClose = pane.state.isClosable || editable;
      pane.state.index = "" + index;
      var btnClose = withClose ? h("span", {
        "class": "tiny-tabs__icon-close"
      }, [h("icon-close", {
        "on": {
          "click": function click(e) {
            onTabRemove(pane, e);
          }
        }
      })]) : null;
      var tipComp = function tipComp2() {
        return tooltipConfig === "title" ? h("span", {
          class: "tiny-tabs__item__title",
          attrs: {
            title: pane.title
          }
        }, [pane.title]) : h(Tooltip, {
          class: "tiny-tabs__item__title",
          props: _extends({
            content: pane.title
          }, tooltipConfig)
        }, [h("span", {}, [pane.title])]);
      };
      var toolTipComp = function toolTipComp2() {
        return tooltipConfig ? tipComp() : h("span", {
          class: "tiny-tabs__item__title"
        }, [pane.title]);
      };
      var tabLabelContent = function tabLabelContent2() {
        return pane.$slots.title ? pane.$slots.title() : toolTipComp();
      };
      var tabindex = pane.state.active ? 0 : -1;
      return h("div", {
        ref: "tabs-" + tabName,
        key: "tab-" + tabName + "-" + index,
        class: (_class = {
          "tiny-tabs__item": true
        }, _class["is-" + state.rootTabs.position] = true, _class["is-active"] = pane.state.active, _class["is-disabled"] = pane.disabled, _class["is-closable"] = withClose, _class["is-focus"] = state.isFocus, _class),
        attrs: {
          id: "tab-" + tabName,
          "aria-controls": "pane-" + tabName,
          role: "tab",
          "aria-selected": pane.state.active,
          tabindex,
          refInFor: true
        },
        on: {
          focus: function focus() {
            setFocus();
          },
          blur: function blur() {
            removeFocus();
          },
          click: function click(e) {
            removeFocus();
            onTabClick(pane, tabName, e);
          },
          keydown: function keydown(e) {
            if (withClose && (e.keyCode === 46 || e.keyCode === 8)) {
              onTabRemove(pane, e);
            }
          }
        }
      }, [tabLabelContent(), btnClose]);
    });
    var paddingRight = this.$refs.more ? this.$refs.more.offsetWidth + "px" : "46px";
    return h("div", {
      "style": showMoreTabs ? {
        paddingRight
      } : {},
      "class": ["tiny-tabs__nav-wrap", state.scrollable ? "is-scrollable" : "", showMoreTabs ? "is-show-more" : "", "is-" + state.rootTabs.position]
    }, [[scrollBtn, moreTabs], h("div", {
      "class": ["tiny-tabs__nav-scroll"],
      "ref": "navScroll"
    }, [h("div", {
      "class": ["tiny-tabs__nav", "is-" + state.rootTabs.position, stretch && ["top", "bottom"].includes(state.rootTabs.position) ? "is-stretch" : "", !tabStyle ? "is-show-active-bar" : ""],
      "ref": "nav",
      "style": state.navStyle,
      "attrs": {
        "role": "tablist"
      },
      "on": {
        "keydown": changeTab
      }
    }, [!tabStyle ? h("tab-bar", {
      "ref": "tabBar",
      "attrs": {
        "tabs": panes
      }
    }) : null, tabs])])]);
  }
};
var __vue2_render$1, __vue2_staticRenderFns$1;
var __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(__vue2_script$1, __vue2_render$1, __vue2_staticRenderFns$1, false, __vue2_injectStyles$1, null, null, null);
function __vue2_injectStyles$1(context) {
  for (var o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var TabNav = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var __vue2_script = defineComponent({
  emits: ["add", "click", "close", "edit", "update:modelValue", "tab-drag-start", "tab-drag-over", "tab-drag-end"],
  props: [].concat(props, ["tabStyle", "activeName", "withClose", "withAdd", "size", "modelValue", "editable", "position", "beforeLeave", "stretch", "showMoreTabs", "popperClass", "popperAppendToBody", "dropConfig", "tooltipConfig"]),
  components: {
    TabNav,
    IconPlus: iconPlus()
  },
  provide: function provide() {
    return {
      moreIcon: this.$slots.moreIcon
    };
  },
  setup: function setup3(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless: renderless$2,
      api: api$2
    });
  },
  render: function render4() {
    var _this = this, _class2;
    var h = arguments[0];
    var state = this.state, tabStyle = this.tabStyle, handleTabClick = this.handleTabClick, handleTabRemove = this.handleTabRemove, handleTabAdd = this.handleTabAdd, handleTabDragStart = this.handleTabDragStart, handleTabDragOver = this.handleTabDragOver, handleTabDragEnd = this.handleTabDragEnd, editable = this.editable, withAdd = this.withAdd, position = this.position, size = this.size, stretch = this.stretch, showMoreTabs = this.showMoreTabs, popperClass = this.popperClass, popperAppendToBody = this.popperAppendToBody, dropConfig = this.dropConfig, tooltipConfig = this.tooltipConfig;
    var newButton = editable || withAdd ? h("span", {
      "class": "tiny-tabs__new-tab",
      "on": {
        "click": handleTabAdd,
        "keydown": function keydown(ev) {
          if (ev.keyCode === 13) {
            handleTabAdd();
          }
        }
      },
      "attrs": {
        "tabindex": "0"
      }
    }, [h("icon-plus")]) : null;
    var navData = {
      props: {
        currentName: state.currentName,
        panes: state.panes,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        showPanesCount: state.showPanesCount,
        editable,
        tabStyle,
        size,
        stretch,
        showMoreTabs,
        popperClass,
        popperAppendToBody,
        dropConfig,
        tooltipConfig
      },
      on: {
        "tab-drag-start": handleTabDragStart,
        "tab-drag-over": handleTabDragOver,
        "tab-drag-end": handleTabDragEnd
      },
      ref: "nav"
    };
    var TabNavComponent = h(TabNav, _extends({}, navData));
    this.$nextTick(function() {
      _this.$refs.nav && _this.$refs.nav.$forceUpdate();
    });
    var header = h("div", {
      "class": ["tiny-tabs__header", "is-" + position]
    }, [TabNavComponent, newButton]);
    var panels = h("div", {
      "class": "tiny-tabs__content"
    }, [this.slots.default && this.slots.default()]);
    return h("div", {
      "class": (_class2 = {
        "tiny-tabs": true,
        "tiny-tabs--card": tabStyle === "card"
      }, _class2["tiny-tabs--" + position] = true, _class2["tiny-tabs--border-card"] = tabStyle === "border-card", _class2["tiny-tabs--button-card"] = tabStyle === "button-card", _class2["tiny-tabs--small"] = size === "small", _class2)
    }, [position !== "bottom" ? [header, panels] : [panels, header]]);
  }
});
var __vue2_render, __vue2_staticRenderFns;
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
